// A region page normally lists resorts that all sit inside that one
// geographic region, so repeating the region name on every row is noise.
// Logical regions (season passes such as Ikon or Epic) group resorts that
// span several primary regions, and there the region name is what tells
// "Brighton, Utah" apart from a same-named resort elsewhere.
//
// Derived from the rows rather than from IRegionShort.isLogical: it is the
// rendered list that decides whether the suffix disambiguates anything, and
// a logical region whose resorts happen to share one primary region gains
// nothing from it.
export const spansMultipleRegions = (rows: Array<{ region_id?: string }>): boolean => {
  const ids = new Set<string>();
  rows.forEach((r) => {
    if (r.region_id) {
      ids.add(r.region_id);
    }
  });
  return ids.size > 1;
};
